import * as classes from './Symptoms.module.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const Symptoms = ({ content }) => {
  if (!content) return (<></>)

  return (
    <section className={`container-sm ${classes.sectionSymptoms}`}>
      <div className={'container-text ul-checked'}>
        {documentToReactComponents(content)}
      </div>
    </section>
  )
}

export default Symptoms
